import { JsonObject, JsonProperty } from 'json2typescript';
import { SearchParams } from '../searchParams';

@JsonObject('EventSearchParams')
export class EventSearchParams extends SearchParams {
    @JsonProperty('start_range_before', String, true)
    startBefore = null;

    @JsonProperty('start_range_after', String, true)
    startAfter = null;
}
